import * as Yup from 'yup';
import { ProvisionalPromotionFormValues } from '../types/ProvisionalPromotionTypes';

const provisionalPromotionSchema = Yup.object({
  academicYear: Yup.string().required('Academic Year is required'),
  grade: Yup.string().required('Grade is required'),
  division: Yup.string().required('Division is required'),
  applicableConcessions: Yup.array().of(Yup.string()).optional()
});

const defaultProvisionalPromotionFormValues: ProvisionalPromotionFormValues = {
  academicYear: '',
  grade: '',
  division: '',
  applicableConcessions: []
};

export { provisionalPromotionSchema, defaultProvisionalPromotionFormValues };
